"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDoctorAttendingsWithInvitationsListApiResponseSchema = exports.getDoctorAttendingWithInvitationsItemApiResponseSchema = exports.doctorAttendingListOfficeApiSchema = exports.doctorAttendingInvitationStatusesSchema = exports.doctorAttendingInvitationStatuses = void 0;
const zod_1 = require("zod");
const api_1 = require("../global/api");
const paginate_list_api_response_schema_1 = require("../global/paginate-list-api-response.schema");
exports.doctorAttendingInvitationStatuses = [
    'pending',
    'confirmed',
    'expired',
];
exports.doctorAttendingInvitationStatusesSchema = zod_1.z.enum(exports.doctorAttendingInvitationStatuses);
/**
 * One office an attending doctor practises in. Each office is activated
 * separately, hence its own `activatedAt`.
 */
exports.doctorAttendingListOfficeApiSchema = zod_1.z.object({
    officeId: zod_1.z.string(),
    officeName: zod_1.z.string(),
    activatedAt: zod_1.z.coerce.date().nullable().default(null),
});
exports.getDoctorAttendingWithInvitationsItemApiResponseSchema = zod_1.z.object({
    id: zod_1.z.string(),
    type: (0, api_1.apiEntityTypeSchema)('doctor-attendings'),
    attributes: zod_1.z.object({
        firstname: zod_1.z.string(),
        lastname: zod_1.z.string(),
        email: zod_1.z.string(),
        orderRegistrationNumber: zod_1.z.string(),
        iban: zod_1.z.string().nullable(),
        bic: zod_1.z.string().nullable(),
        commissionRate: zod_1.z.number().nullable(),
        officeId: zod_1.z.string(),
        officeName: zod_1.z.string(),
        offices: zod_1.z.array(exports.doctorAttendingListOfficeApiSchema).default([]),
        status: exports.doctorAttendingInvitationStatusesSchema,
        isInvite: zod_1.z.boolean(),
        createdAt: zod_1.z.coerce.date(),
        activatedAt: zod_1.z.coerce.date().nullable(),
        deactivatedAt: zod_1.z.coerce.date().nullable().default(null),
    }),
});
exports.getDoctorAttendingsWithInvitationsListApiResponseSchema = (0, paginate_list_api_response_schema_1.paginteListApiResponseSchema)(exports.getDoctorAttendingWithInvitationsItemApiResponseSchema);
